import React from 'react';
import {Button, Tooltip} from '@chakra-ui/react';
import {TbSettingsPlus} from "react-icons/tb";
export default function CreateServiceModalButton({disabledButton, appointment, isVisible = true, ...props}) {
  if (!isVisible) return null;
  return (
    <Tooltip
      label="Arızalı ürünleri teknik servise göndermek için kayıt oluştur."
      bg='gray.100'
      color="black"
      placement='bottom'
    >
      <Button isDisabled={disabledButton} leftIcon={<TbSettingsPlus />} {...props}>
        Servis kaydı
      </Button>
    </Tooltip>

  )
}
